import { render, staticRenderFns } from "./tooling-restricted-toggle.component.vue?vue&type=template&id=07e74d89&scoped=true"
import script from "./tooling-restricted-toggle.component.vue?vue&type=script&lang=ts"
export * from "./tooling-restricted-toggle.component.vue?vue&type=script&lang=ts"
import style0 from "./tooling-restricted-toggle.component.vue?vue&type=style&index=0&id=07e74d89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e74d89",
  null
  
)

export default component.exports